'use client';

import { useSearchParams } from 'next/navigation';
import { GalleryImage } from "@/components/gallery25";
import { useMemo } from 'react';
import dynamic from 'next/dynamic';

const Gallery25 = dynamic(() => import('@/components/gallery25'), { 
    ssr: false,
    loading: () => <div className="py-32 container animate-pulse bg-muted rounded-lg h-[50vh]" />
  });
  
interface CategoryGalleryClientProps {
    images: GalleryImage[];
    categoryUrl: string;
    categorySlug?: string;
    categoryDescriptions?: Record<string, string>;
    categoryDisplayName?: string;
    ecommerceEnabled?: boolean;
    showExifData?: boolean;
}

export function CategoryGalleryClient({ images, categoryUrl, categorySlug, categoryDescriptions, categoryDisplayName, ecommerceEnabled = false, showExifData = false }: CategoryGalleryClientProps) {
    const searchParams = useSearchParams();
    const initialOpenSlug = searchParams.get('openSlug');

    // Images are pre-sorted by numeric prefix on the server side
    // No client-side sorting needed

    const cleanReturnUrl = useMemo(() => {
        if (initialOpenSlug && typeof window !== 'undefined') {
            const url = new URL(window.location.href);
            url.searchParams.delete('openSlug');
            return url.pathname + url.search;
        }
        return categoryUrl; 
    }, [initialOpenSlug, categoryUrl]);

    return (
        <Gallery25
            images={images}
            returnUrl={cleanReturnUrl}
            initialSlug={initialOpenSlug || undefined}
            categorySlug={categorySlug}
            categoryDescriptions={categoryDescriptions}
            categoryDisplayName={categoryDisplayName}
            ecommerceEnabled={ecommerceEnabled}
            showExifData={showExifData}
        />
    );
}
